/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeaderPaymentMenu: FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-5">
        <Link to={`payment/add`} className="menu-link px-5">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.31641 17.388C6.96241 19.574 9.56941 21 12.5004 21C17.4504 21 21.5004 16.95 21.5004 12C21.5004 7.05 17.4504 3 12.5004 3"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M5.316 17.388C4.182 15.882 3.5 14.019 3.5 12C3.5 7.05 7.55 3 12.5 3"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-dasharray="0"
            ></path>
            <path
              d="M12.25 7V8.25"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M12.25 17V15.75"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M14.737 10C14.672 9.024 13.867 8.25 12.875 8.25H11.505C10.535 8.25 9.75 9.036 9.75 10.005C9.75 10.81 10.298 11.512 11.078 11.708L13.421 12.296C14.202 12.492 14.749 13.194 14.749 13.999C14.749 14.969 13.963 15.754 12.994 15.754H11.624C10.63 15.754 9.825 14.978 9.761 14"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          {t("PAYMENT.ADD_CREDIT")}
        </Link>
        <Link to="payment/history" className="menu-link px-5">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.998 8H16.998C16.446 8 15.998 7.552 15.998 7V3"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M6.99805 9.5V8V5C6.99805 3.895 7.89305 3 8.99805 3H16.17C16.7 3 17.209 3.211 17.584 3.586L20.412 6.414C20.787 6.789 20.998 7.298 20.998 7.828V19C20.998 20.105 20.103 21 18.998 21H8.99805C7.89305 21 6.99805 20.105 6.99805 19V18"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M4.90148 12.0303L2.99148 13.9403L5.02148 15.9703"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M2.99219 13.9404L10.9961 13.9404"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          {t("PAYMENT.TRANSACTIONS")}
        </Link>
      </div>
    </div>
  );
};

export { HeaderPaymentMenu };
